import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import Button from 'components/Button'

const bem = new BEMHelper('step')

export default function Step({
  title,
  children,
  onSubmit,
  submit,
  info,
  footerSpacing,
  submitDisabled,
  isLoading,
}) {
  const handleSubmit = (event) => {
    event.preventDefault()

    if (onSubmit && !submitDisabled) {
      onSubmit()
    }
  }

  return (
    <form {...bem('')} onSubmit={handleSubmit} autoComplete="off">
      <h1 {...bem('title')}>{title}</h1>
      {info && <p {...bem('info')}>{info}</p>}
      <div {...bem('content')}>{children}</div>

      {submit && (
        <div {...bem('footer', { spacing: footerSpacing })}>
          <Button primary arrow type="submit" disabled={submitDisabled} loading={isLoading}>
            {submit}
          </Button>
        </div>
      )}
    </form>
  )
}

Step.propTypes = {
  title: T.string.isRequired,
  children: T.any.isRequired,
  onSubmit: T.func,
  submit: T.string,
  info: T.string,
  footerSpacing: T.bool,
  submitDisabled: T.bool,
  isLoading: T.bool,
}
